import "./App.css";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./pages/login/Login";
import MiddlewareAuth from "./components/middleware/MiddlewareAuth";
import Loading from "./components/main/Loading";
import Toast from "./components/main/Toast";
import Home from "./pages/home/Home";
import { ToastContainer } from "react-toastify";
import ForgotPassword from "./pages/login/ForgotPassw";
import Sales from "./pages/sales/Sales";
import NewSale from "./pages/sales/NewSale";
import Sellers from "./pages/sellers/Sellers";
import Categories from "./pages/categories/Categories";
import Departments from "./pages/departaments/Departments";
import Products from "./pages/products/Products";
import ProductsSales from "./pages/sales/detail/ProductsSales";
import ClientsFollow from "./pages/clients/ClientsFollow";
import ClientDetail from "./pages/clients/ClientDetail";

const App = () => {
  return (
    <>
      <Toast />
      <ToastContainer />
      <Loading />
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgotPassword" element={<ForgotPassword />} />

          <Route
            path="/inicio"
            element={
              <MiddlewareAuth>
                <Home />
              </MiddlewareAuth>
            }
          />
          {
            /*sales*/
          }
          <Route
            path="/ventas"
            element={
              <MiddlewareAuth>
                <Sales />
              </MiddlewareAuth>
            }
          />
          <Route
            path="/venta/:id"
            element={
              <MiddlewareAuth>
                <ProductsSales />
              </MiddlewareAuth>
            }
          />

          <Route
            path="/ventas/nueva"
            element={
              <MiddlewareAuth>
                <NewSale />
              </MiddlewareAuth>
            }
          />
          {
            /*sellers*/
          }
          <Route
            path="/vendedores"
            element={
              <MiddlewareAuth>
                <Sellers />
              </MiddlewareAuth>
            }
          />
          {
            /*departaments*/
          }
          <Route
            path="/departamentos"
            element={
              <MiddlewareAuth>
                <Departments />
              </MiddlewareAuth>
            }
          />
          {
            /*products*/
          }
          <Route
            path="/productos"
            element={
              <MiddlewareAuth>
                <Products />
              </MiddlewareAuth>
            }
          />
          {
            /*categories*/
          }
          <Route
            path="/areas"
            element={
              <MiddlewareAuth>
                <Categories />
              </MiddlewareAuth>
            }
          />


          {/*Clients*/}

          <Route
            path="/clients-follow"
            element={
              <MiddlewareAuth>
                <ClientsFollow />
              </MiddlewareAuth>
            }
          />

          <Route
            path="/cliente/:id"
            element={
              <MiddlewareAuth>
                <ClientDetail />
              </MiddlewareAuth>
            }
          />

          <Route
            path="/loader"
            element={
              <MiddlewareAuth>
                <div
                  className={`transition duration-700 ease-in-out  w-full h-screen fixed left-20 top-20 z-10 justify-center items-center bg-black bg-opacity-70 flex`}
                >
                  En construcción...{" "}
                  <svg
                    className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                </div>
              </MiddlewareAuth>
            }
          />

          {/* Ruta catch-all: redirecciona al home */}
          <Route path="*" element={<Navigate to="/inicio" replace />} />
        </Routes>
      </Router>
    </>
  );
};

export default App;
